export default __webpack_public_path__ + "static/media/384.b59002e8.gif";